import Main from "./Main.js";
import Pqp from "../3x1010/Pqp.js";

export default class Scene {
	constructor() {

	}

	static setSceneNames() {
		
		jQuery(".js-orienta").hide();
		let pano = Scene.pano;
		let quante = pano.get("scene.count");
		for (var x = 0; x < quante; x++) {
			let sceneXml = pano.get("scene[" + x + "]");
			let scene = Scene.getSceneByName(sceneXml.name);
			pano.set("scene[" + x + "].title", scene["title_" + Scene.userLang.toLowerCase()]);
			pano.set("scene[" + x + "].onstart", "js(trixProxy('Main','moveAndTag','reached-station','" + Scene.userLang.toLowerCase() + "', '" + scene.name + "'))");
			//pano.set("scene[" + x + "].view.maxpixelzoom", "1.0");
		}
		Scene.setHotspotsAction();
	}

	static gotoScene(spot, first) {
		console.log("-gotoScene-")
		let pano = Scene.pano;
		let name = (Scene.getSceneBySpot(spot)).name;
		console.log(name);

		pano.call("loadscene(" + name + ");");
		//console.log(this.pano.get("events"))
		if (!first) {
			//setTimeout(jQuery.proxy(Main.that.showInfoForced, Main.that), 100);
		}

		// Forza il lookat
		let scene = Scene.getSceneBySpot(spot);
		if (Main.that.fhlookat) {
			scene = {
				hlookat: "" + Main.that.fhlookat,
				vlookat: "" + Main.that.fvlookat
			}
			//console.log(scene)
			Main.that.fhlookat = null;
			Main.that.vhlookat = null;
		}

		if (!Pqp.isNullOrEmpty(scene.hlookat)) {
			this.pano.set("view.hlookat", parseFloat(scene.hlookat));
		}
		if (!Pqp.isNullOrEmpty(scene.vlookat)) {
			this.pano.set("view.vlookat", parseFloat(scene.vlookat));
		}

	}

	static getSceneBySpot(spot) {
		let pano = Scene.pano;
		let a = SceneList.SCENE;
		for (let x = 0; x < a.length; x++) {
			if (a[x].spot == spot) {
				return a[x];
			}
		}
		return a[0];
	}

	static getSceneByName(sceneName) {
		let a = SceneList.SCENE;
		for (let x = 0; x < a.length; x++) {
			if (a[x].name.toLowerCase() == sceneName.toLowerCase()) {
				return a[x];
			}
		}
		return a[0];
	}

	static getCurrentXmlScene(){
		let pano = Scene.pano;
		return pano.get("xml");
	}

	static getCurrentScene(){
		let pano = Scene.pano;
		let name = pano.get("xml").scene;
		return Scene.getSceneByName(name);
	}

	static setHotspotsAction(){
		let pano = Scene.pano;
		let quanti = pano.get('hotspot.count');
		let elenco = ""
		let elenco50 = ""
		for (var x = 0; x < quanti; x++) {
			var hs = pano.get('hotspot[' + x + ']');
			if (hs.scene_el) {
				// Controlla se la scena ha un corrispettivo in SceneList
				let sceneLocal = this.getHotspotByName(hs.title);

				let setta = true;
				if (hs.title.toLowerCase().indexOf("navigation") >= 0) {
					setta = false
				}
				if (hs.url) {
					if (hs.url.toLowerCase().indexOf("videoplayer.js") >= 0) {
						setta = false
					}
				}

				hs.onhover = "";

				if (setta) {
					hs.onclick = "js(trixProxy('Main','handleHotspot','" + hs.title + "'));";
					hs.ondown = "";

					let tmp = hs.title.split("_");
					let num = parseInt(tmp[tmp.length - 1]);
					if (num >= 50) {
						hs.zorder = "0";
						let newhs = tmp[0] + "_" + tmp[1] + "_" + Scene.padr("" + (num - 50), "0", 2);
						//console.log(newhs)
						hs.onclick = "js(trixProxy('Main','handleHotspot','" + newhs + "'));";
						sceneLocal = true;

						// Controlla se esiste il corrispettivo
						let sceneMeno50 = this.getHotspotByName(newhs);

						if (!sceneMeno50) {
							elenco50 += hs.title + "\n";
						}


					}
				}
				if (hs.title.toLowerCase().indexOf("dummy") >= 0) {
					sceneLocal = true;
				}

				if (!sceneLocal) {
					elenco += hs.title + "\n";
				}


				// Spostato fuori così li fa tutti
				if (hs.url) {
					if (hs.url.toLowerCase().indexOf("hs_cerchi") >= 0) {
						// mmmh che profumino, cosa avete cucinato?
						let w = hs.width;
						hs.width = 1;
						hs.oldWidth = w;
						//console.log("setto "+ hs.title + " " + w)
						hs.ondown = "trix_animation(64,64, 20);"
						if (!Scene.animationTriggerNew) {
							hs.onloaded = "js(Scene.startHsAnimation(" + x + "," + w + "))" // PQP 
							setTimeout(jQuery.proxy(this.startHsAnimation, this, hs, w), 3000); // PQP
						} else {
							hs.triggeraAnimazione = true;
						}
					}
				}

			}
		}
		if (elenco.length > 0) {
			Main.debugTrace("Hotspot orfani")
			Main.debugTrace(elenco);
		}

		if (elenco50.length > 0) {
			Main.debugTrace("Hotspot orfani 50")
			Main.debugTrace(elenco50);
		}

	}
	static padr(sString, sChar, nQuanti) {
		var n;
		n = sString.length;
		for (var x = 0; x < (nQuanti - n); x++) {
			sString = sChar + sString;
		}
		return sString;
	};

	
	/*Scene.startHsAnimation(hs) {
		let pano = Scene.pano;
		if (typeof (hs) == "string") {
			hs = pano.get('hotspot[' + hs + ']');
		}
		if (hs) {
			if (Scene.fatte.indexOf(hs.name) < 0) {
				//console.log("Animazione triggerata per " +hs.title)
				Scene.fatte.push(hs.name);
				// hs.width = w; //PQP
				hs.width = hs.oldWidth;
				hs.triggerevent("ondown");
				hs.ondown = "" // PQP
			}
		}
	}*/

	static startHsAnimation(hs, w) {
		let pano = Scene.pano;
		if (typeof (hs) == "string") {
			hs = pano.get('hotspot[' + hs + ']');
			w = parseInt(w);
		}
		if (hs) {
			if (Scene.fatte.indexOf(hs.name) < 0) {
				//console.log("Animazione triggerata per " +hs.title)
				//console.log(hs.title + " "+ hs.width+ " " +w + " " +hs.oldWidth)

				Scene.fatte.push(hs.name);
				if (hs.oldWidth) {
					hs.width = hs.oldWidth; //PQP
				} else {
					hs.width = w; //PQP
				}
				hs.triggerevent("ondown");
				hs.ondown = "" // PQP
				hs.onloaded = ""


			}
		}
	}
	/*
	Scene.startHsAnimation(hs, w) {
		let pano = Scene.pano;
		if (typeof (hs) == "string") {
			hs = pano.get('hotspot[' + hs + ']');
			w = parseInt(w);
		}
		if (hs) {
			if (Scene.fatte.indexOf(hs.name) < 0) {
				//console.log(hs.title + " "+ hs.width+ " " +w + " " +hs.oldWidth)
				//console.log("Animazione triggerata per " +hs.title)
				Scene.fatte.push(hs.name);
				hs.width = w; //PQP
				hs.triggerevent("ondown");
				hs.ondown = "" // PQP
				
	
			}
		}
	}
	*/
	static getHotspotByName(name) {
		let a = SceneList.SCENE;
		for (let x = 0; x < a.length; x++) {
			let scene = a[x];
			if (scene.hotspots) {
				for (let y = 0; y < scene.hotspots.length; y++) {
					if (scene.hotspots[y].name.toLowerCase() == name.toLowerCase()) {
						return scene.hotspots[y];
					}
				}
			}
		}
		return null;
	}

	/*
	Scene.getHotspotTitle(sceneName, hotspotName) {
		//console.log(sceneName,hotspotName)
		let scene = Scene.getSceneByName(sceneName);
		if (scene.hotspots) {
			let a = scene.hotspots;
			for (let x=0;x<a.length;x++){
				if (a[x].name.toLowerCase() == hotspotName.toLowerCase()){
					return a[x]["title_" + Scene.userLang.toLowerCase()];
				}
			}
		}
		return null;
	}*/
}

Scene.fatte = [];
Scene.pano = undefined;
Scene.userLang = undefined;
Scene.animationTriggerNew = true;
